import { apiService } from '../../shared'

const getEventDetailsInfo = async (eventId) => {
    return await apiService.get(`/events/${eventId}`, { fields: ['reminders'] })
}

export {
    getEventDetailsInfo
}   
